'use strict';

angular.module('internal.applications')
    .controller('InternalApplicationResponses', ['$scope', function ($scope) {
        $scope.resetApplication();
    }])
;